var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenspaceIconWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1308 43.1141H44.1808V43.0641V9.80322V9.75322H44.1308H10.8699H10.8199V9.80322V43.0641V43.1141H10.8699H44.1308ZM11.9444 6.48359H43.0556C45.4724 6.48359 47.45 8.46121 47.45 10.878V41.9892C47.45 44.406 45.4724 46.3836 43.0556 46.3836H11.9444C9.52761 46.3836 7.55 44.406 7.55 41.9892V10.878C7.55 8.46121 9.52761 6.48359 11.9444 6.48359ZM16.4389 22.0391H20.7833V37.4947H16.4389V22.0391ZM25.3278 15.3725H29.6722V37.4947H25.3278V15.3725ZM34.2167 28.7058H38.5611V37.4947H34.2167V28.7058Z",
    fill: "#646AFF",
    stroke: "#F5F5F5",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenspaceIconWork);
export default __webpack_public_path__ + "static/media/genspace-icon-work.690d42a5f346ad65dc9ee65da01a72f8.svg";
export { ForwardRef as ReactComponent };